import Http from 'common/services/Http';
import CustomFile from 'common/models/CustomFile';

export interface BudgetLineImageUploadResult {
    attachmentId: string;
    fileName: string;
    mimeType: string;
    size: number;
    url: string;
}

class BudgetLineImagesService {
    public uploadPending (file: CustomFile): Promise<BudgetLineImageUploadResult> {
        return Http.postWithFile<BudgetLineImageUploadResult>('budgetLineImages/upload', {}, [file]);
    }
}

export default new BudgetLineImagesService();
